import React from 'react'

export default function LoadingDownload() {
  return (
    <div className="loading-animation-download">
    <div className="loading-animation-download__sprite"/>
  </div>
  )
}
